var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.getSelectedDEV && 'dev-selected-component'],style:(_vm.schema.attributes && _vm.schema.attributes.style),attrs:{"id":_vm.setId(_vm.schema.model)},domProps:{"innerHTML":_vm._s(_vm.value)},on:{"contextmenu":function($event){return _vm.selectComponentDEV($event, _vm.schema.model)}}},[_vm._v(" "+_vm._s(_vm.value)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }